export default {"src":"/_next/static/media/Tuesday.f4aeacaf.svg","height":1214,"width":1114};